export default __webpack_public_path__ + "static/O0217-f7c002cca3bacf810685599e852652ea.png";